import { WidgetRendererBase } from "../widget-renderer-base";
import { StoreOrderDetailsWidgetScriptRenderer } from "./store-order-details-widget-script.renderer";
import { IStoreOrderDetailsWidgetData } from "@pageBuilder/typings";
import { IRenderingCommonContext } from "@commonRendering/types";

export class StoreOrderDetailsWidgetRenderer extends WidgetRendererBase<IStoreOrderDetailsWidgetData> {

    protected override renderStyles(element: HTMLElement, data: IStoreOrderDetailsWidgetData): void {
        this.animationRenderer.setAnimationStyles(element, data?.style.animation);
    }

    private readonly scriptRenderer: StoreOrderDetailsWidgetScriptRenderer;

    constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);

        this.scriptRenderer = new StoreOrderDetailsWidgetScriptRenderer();
    }

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("storeOrderDetailsWidget");
    }

    protected renderInternal(element: HTMLElement, data: IStoreOrderDetailsWidgetData): HTMLElement {
        this.setAttributes(element, data);
        this.renderStyles(element, data);
        this.renderScripts(element);

        return element;
    }

    private setAttributes(element: HTMLElement, data: IStoreOrderDetailsWidgetData): void {
        if (data.orderDataBase64) {
            element.dataset.orderModel = data.orderDataBase64;
        }

        if (data.primaryElement) {
            element.dataset.primaryElement = "true";
        } else {
            delete element.dataset.primaryElement;
        }

        if (this.isEditorRendering) {
            element.dataset.draft = "true";
        }
    }

    private renderScripts(element: HTMLElement): void {
        this.scriptRenderer.renderCommon(this.renderedDocument);
        this.scriptRenderer.renderLocal(element);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override getContentSelectorsInternal(element: HTMLElement): string[] {
        return [];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected cleanupInternal(element: HTMLElement): void {
        //nothing
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private cleanupStyle(element: HTMLElement): void {
        //nothing
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private cleanupButtonStyles(element: HTMLElement): void {
        //nothing
    }

}
